import {Component, OnInit} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {NotificationService} from '../../../../Services/notification.service';
import {DataService} from '../../../../Services/data.service';
import {AppConfigService} from '../../../../Services/app-config.service';
import {Router} from '@angular/router';
import {DateFilterService} from '../../../../Services/dateFilter.service';
import {ResponseModel} from '../../../../DataModels/response-model';
import {NgbPaginationConfig} from '@ng-bootstrap/ng-bootstrap';
import {PagerStateService} from '../../../../Services/pager-state.service';
import {NgbpaginationConfigService} from '../../../../Services/ngbpagination-config.service';
import {ListPageBase} from '../../../list-page-base';

@Component({
  selector: 'app-sys-user-list',
  templateUrl: './sys-user-list.component.html',
  styleUrls: ['./sys-user-list.component.css'],
  standalone: false
})
export class SysUserListComponent extends ListPageBase implements OnInit {
  constructor(
              private titleService: Title,
              private toastr: NotificationService,
              private tableDataService: DataService,
              private notification: NotificationService,
              private dateFilter: DateFilterService,
              private ngbConfig: NgbPaginationConfig,
              private pagerConfig: NgbpaginationConfigService
  ) {
    super();
    this.ngbConfig = this.pagerConfig.getNgbPaginationConfig();
  }

  vm: any = {
    list: [],
    rfType: '',
    title: 'System Users',
    Preferences: [],
    permissions: [],
    listInitiated: false,
    sysUserFilter: {text: null},
    formRoute: '/admin/sys-user/form'
  };

  isLoaded = false;



  ngOnInit() {
    this.restorePagerState();
    this.vm.list = [];
    this.titleService.setTitle($localize`:System User List@@systemUserList:System User List`);
    this.getData();
  }

  getData() {
    let paramString = '?search=' + ((this.vm.searchTerm) ? this.vm.searchTerm : '');
    paramString += '&fromDate=' + ((this.vm.fromDate) ? this.dateFilter.GetDateFormat(this.vm.fromDate) : '');
    paramString += '&toDate=' + ((this.vm.toDate) ? this.dateFilter.GetDateFormat(this.vm.toDate) : '');
    paramString += '&pageNumber=' + ((this.page !== 0) ? this.page - 1 : 0);
    paramString += '&pageSize=' + this.pageSize;

    this.tableDataService.getApiListData('sys_user', paramString).subscribe((result: ResponseModel) => {
      this.vm.list = result.Data;
      this.totalRecords = result.totalRecords;
      this.paginate(false);

      this.vm.listInitiated = true;
      this.isLoaded = true;
    });
  }

  onNavigate(aID: string) {
    this.router.navigate(['admin/sys-user-form', {id: aID}]);
  }

  // ----------------- Server side paging --------------------

  protected fetchPage(): void {
    this.getPagedApiData();
  }

  getPagedApiData() {
    let paramString = '?search=' + ((this.vm.searchTerm) ? this.vm.searchTerm : '');
    paramString += '&fromDate=' + ((this.vm.fromDate) ? this.dateFilter.GetDateFormat(this.vm.fromDate) : '');
    paramString += '&toDate=' + ((this.vm.toDate) ? this.dateFilter.GetDateFormat(this.vm.toDate) : '');
    paramString += '&pageNumber=' + ((this.page !== 0) ? this.page - 1 : 0);
    paramString += '&pageSize=' + this.pageSize;

    this.tableDataService.getApiListData('sys_user', paramString).subscribe((result: ResponseModel) => {
      this.vm.list = result.Data;
      this.totalRecords = result.totalRecords;
      this.paginate(false);

      this.vm.listInitiated = true;
      this.isLoaded = true;
    });
  }

  serverSearch(value) {
    this.vm.searchTerm = value.searchTerm;
    this.vm.fromDate = value.fromDate;
    this.vm.toDate = value.toDate;
    this.page = 1;
    this.getPagedApiData();
  }

  clearServerSearch(value) {
    this.vm.searchTerm = value.searchTerm;
    this.vm.fromDate = value.fromDate;
    this.vm.toDate = value.toDate;
    this.page = 1;
    this.getPagedApiData();
  }

  hideSearch() {
    this.vm.searchHidden = !this.vm.searchHidden;
  }
}
